import { render, staticRenderFns } from "./DelegationReadonlyView.vue?vue&type=template&id=a234eee8&scoped=true&"
import script from "./DelegationReadonlyView.vue?vue&type=script&lang=js&"
export * from "./DelegationReadonlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a234eee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a234eee8')) {
      api.createRecord('a234eee8', component.options)
    } else {
      api.reload('a234eee8', component.options)
    }
    module.hot.accept("./DelegationReadonlyView.vue?vue&type=template&id=a234eee8&scoped=true&", function () {
      api.rerender('a234eee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationReadonlyView.vue"
export default component.exports